import React, { memo } from "react";
import styles from "./PreviewCard.module.css";

interface PreviewCardProps {
  title: string;
  timestamp: string;
  onSelect?: () => void;
  isSelected?: boolean;
  preview?: string | null;
  processingStatus?: "pending" | "processing" | "complete" | "error" | null;
}

const formatTime = (dateString: string) => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
};

const PreviewCard: React.FC<PreviewCardProps> = memo(
  ({
    title,
    timestamp,
    onSelect,
    preview,
    processingStatus,
    isSelected = false,
  }) => {
    const isGenerating =
      processingStatus === "pending" || processingStatus === "processing";
    const isFailed = processingStatus === "error";

    return (
      <button
        type="button"
        onClick={onSelect}
        className={[
          styles.card,
          isSelected ? styles.selected : "",
          isGenerating ? styles.generating : "",
          isFailed ? styles.failed : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <span className={styles.content}>
          <span className={styles.topRow}>
            <span className={styles.title}>{title || "New Thread"}</span>
            <span className={styles.time}>{formatTime(timestamp)}</span>
          </span>

          <span className={styles.previewRow}>
            {isGenerating && <span className={styles.statusDot} />}
            <span className={styles.preview}>
              {isFailed
                ? "Generation interrupted"
                : isGenerating
                  ? "Answering..."
                  : preview || "Ready to continue"}
            </span>
          </span>
        </span>
      </button>
    );
  }
);

export default PreviewCard;
